import React, { useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import SupplierService from "../../../services/SupplierService";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {};

export const DashboardOrderEntrySuccess = (props: Props) => {
    const history = useNavigate();
    const params = useParams();
    const supplierModel = useContext(SupplierContext);

    // @ts-expect-error
    const orderName = params.orderName;
    // @ts-expect-error
    const orderGuid = params.orderGuid;

    const returnToOrderEntry = () => {
        history("/dashboard/ordering");
    };

    return (
        <div className={"DashboardOrderEntrySuccess"}>
            <div className={"row mt-3"}>
                <div className="col">
                    <OwTitle
                        tag={"h3"}
                        title={SupplierService.updateStringWithOrderNameOverride("order_successfully_submitted", supplierModel)}
                    />
                </div>
            </div>

            <div className={"row mt-3"}>
                <div className="col">
                    <OwLabel
                        title={SupplierService.updateStringWithOrderNameOverride("order_no", supplierModel)}
                        postText={":"}
                        className={"me-2"}
                    />
                    <Link to={`/orders/${orderGuid}/entry`}>{orderName}</Link>
                </div>
            </div>

            <div className={"row mt-3"}>
                <div className="col">
                    <OwButton title={"return"} fn={returnToOrderEntry} className={"btn-warning"} />
                </div>
            </div>
        </div>
    );
};
